//* 메뉴 관련 API
import * as BaseApi from "api/Base.api";
const BASE_URL = "/agency/v2/menu";

//* 메뉴에 필요한 모든 카운트 정보 요청
//  2025. 09. 16
//  희문
export interface IMenuCountInfoResponse {
    newNoticeCount: number;
    notReadMessageCount: number;
}
export const fetchMenuCountInfo = async () => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url) as IMenuCountInfoResponse;
};

//* 읽지 않은 채팅 수 조회
//  2025. 09. 16
//  희문
export interface INotReadMessageCountResponse {
    notReadMessageCount: number;
}
export const fetchNotReadMessageCount = async () => {
    const url = `${BASE_URL}/not-read-message-count`;
    return await BaseApi.get(url) as INotReadMessageCountResponse;
};

//* 허브 메뉴용 카운트 정보 요청
export interface IHubMenuCountInfoResponse {
    newNoticeCount: number;
}
export const fetchHubMenuCountInfo = async () => {
    const url = `${BASE_URL}/hub`;
    return await BaseApi.get(url) as IHubMenuCountInfoResponse;
};